







































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { SelectProps, InputResponse } from '@/constants/form/types';

@Component({})
export default class SelectNoVModel extends Vue {
  // セレクトリストデータ
  @Prop({ default: () => ({ name: '', options: [] }) })
  public selectData!: SelectProps;
  // 選択可能か制御
  @Prop({ default: false })
  public isDisabled?: boolean;
  // 入力要素名
  @Prop({ default: '' })
  public label?: string;
  // 初期選択value
  @Prop()
  public selectValue?: { [k: string]: string };
  // content name
  @Prop({ default: '' })
  public name!: string;
  @Prop({ default: '' })
  private rules?: string;

  /**
   * 親コンポーネントに選択値を通知する
   * @module inputOpratipon
   * @return value - 選択した項目
   */
  @Emit('changeSelect')
  public changeSelect(value: { [k: string]: string }) {
    return { name: this.name, value: value };
  }

  createName() {
    if (this.label !== undefined){
      const keyStr = this.name.match(/\[\d{1,}\]/);
      return keyStr !== null  ? this.label+keyStr : this.label;
    }
    return '';
  }
  createMessage(errors: any) {
    const result: string[] = [];
    for(const i in errors) result.push(errors[i].replace(/\[\d{1,}\]/, ''));
    return result;
  }
}
